import React, { useState } from "react";
import {
  Container,
  Form,
  Button,
  Alert,
  InputGroup,
} from "react-bootstrap";
import { FaUser, FaLock } from "react-icons/fa";
import { useLocation, Link } from "react-router-dom";
import InnerBanner from './InnerBanner';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false);

  const location = useLocation();
//   const redirectTo = location.state?.redirectTo || "/";
const redirectTo = "/"; // Always go to homepage after login
  const handleLogin = (e) => {
    e.preventDefault();

    if (email === "admin@example.com" && password === "admin123") {
      localStorage.setItem("user", JSON.stringify({ email }));

      // Force reload to update Header
      window.location.href = redirectTo;
    } else {
      setShowError(true);
    }
  };

  return (
    <>
      <InnerBanner />
      <div className="login-bg">
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
          <div className="login-card">
            <h2 className="text-center login-title">Login</h2>

            {showError && <Alert variant="danger">Invalid credentials</Alert>}

            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3">
                <Form.Label>Username</Form.Label>
                <InputGroup>
                  <InputGroup.Text><FaUser /></InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Type your username"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Password</Form.Label>
                <InputGroup>
                  <InputGroup.Text><FaLock /></InputGroup.Text>
                  <Form.Control
                    type="password"
                    placeholder="Type your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </InputGroup>
              </Form.Group>

              <div className="text-end mb-3">
                <span className="forgot-password">Forgot password?</span>
              </div>

              <Button type="submit" className="login-btn w-100">
                LOGIN
              </Button>
            </Form>

            <div className="text-center mt-4">Don't have an account?</div>
            <div className="signup-link text-center mt-2">
              <Link to="/signup" className="text-decoration-none">SIGN UP</Link>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Login;
